import React from 'react';
import MaterialSelect from './materialSelect';
import SaunaImageContainer from '../containers/SaunaImageContainer';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import localization from '../helpers/localization.js';


const panelSelectionPage = ({
    panelMaterials,
    panelMaterialChanged,
    panelMaterial,
    showPrices,
    panelPrices,
    nextPage,
    prevPage }) => {
    return (<div className="page">
        <SaunaImageContainer />
        <div className="materialSelections">
            <Row>
                <Col md={12} sm={12}><MaterialSelect autoAdjustWidth={true} columnNum={3} materials={panelMaterials} onChange={panelMaterialChanged} header={localization.panelMaterial} selected={panelMaterial} showPrices={showPrices} prices={panelPrices} />
                </Col>          
            </Row>
            <div className="changePhaseRow">
                <span className="orangeButton changePhaseButton" onClick={() => {prevPage()}}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
                <span className="orangeButton changePhaseButton" onClick={() => {nextPage()}}> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></span>
            </div>
        </div>
    </div>
    )
}
export default panelSelectionPage
